import * as plotUtil from '../plot_util'

const t = 0.3;
const FITTING_COUNT = 100;
export default function (coordinates) {
    if (coordinates.length < 3) return [coordinates];
    const points = coordinates.slice();
    points.push(points[0], points[1]);
    let normals = [];
    for (let i = 0; i < points.length - 2; i++) {
        let normalPoints = plotUtil.getBisectorNormals(t, points[i], points[i + 1], points[i + 2]);
        normals = normals.concat(normalPoints);
    }
    let count = normals.length;
    normals = [normals[count - 1]].concat(normals.slice(0, count - 1));

    let pList = [];
    for (let i = 0; i < points.length - 2; i++) {
        let pnt1 = points[i];
        let pnt2 = points[i + 1];
        pList.push(pnt1);
        for (let t = 0; t <= FITTING_COUNT; t++) {
            let pnt = plotUtil.getCubicValue(t / FITTING_COUNT, pnt1, normals[i * 2], normals[i * 2 + 1], pnt2);
            pList.push(pnt);
        }
        pList.push(pnt2);
    }
    return [pList];
}